import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import { IPbmListItem } from '../models'

export const getJbpPbmListCrud = () =>
  CrudStore.get(CrudStoreItemPartner360.JBPPBMs) as Crud<IPbmListItem>
